import * as action from "../actions/index";
import { baseUrl, socket, EVENTS } from "./config";
import { getProfessionalInfo } from "./professionalProvider";

export const storageKey = "userInfo";

export const signIn = (email, password) => async dispatch => {
  dispatch(action.isLoading(true));
  dispatch(action.setLoginError(""));
  try {
    const response = await fetch(`${baseUrl}/login/`, {
      method: "post",
      body: JSON.stringify({ email, password }),
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    //save on local storage
    localStorage.setItem(storageKey, JSON.stringify(result));
    //console.log(result);
    //emit login event to socket.io
    socket.emit(EVENTS.HAS_ENTERED, { userId: result._id });
    subscribeToNotifications(result._id, dispatch);

    dispatch(action.isLoading(false));
    dispatch(action.setLoginError(""));
    dispatch(action.setLoginSuccess(result));
    return result;
  } catch (error) {
    console.log(error);
    dispatch(action.isLoading(false));
    dispatch(action.setLoginError("Não foi possível realizar esta ação."));
  }
};

const subscribeToNotifications = (userId, dispatch) => {
  socket.on(`notification-${userId}`, data => {
    if (data.type == "chat") {
      dispatch(action.addChatNotification());
    }
    if (data.type == "video") {
      if (data.status === "requested") dispatch(action.fetchVideochats(data));
      //else console.log("remove video notification");
    }
    if (data.type == "chat-update") {
      dispatch(action.updateChatList(data.chat, data.chatId, data.lastMessage));
    }
    if (data.type == "consult-update") {
      dispatch(action.updateConsultStatus(data.consultId, data.newStatus));
    }
    if (data.type == "remove-video-notification") {
      dispatch(action.removeVideochat(data.consultId));
    }
  });
};

/* export const signIn = (email, password) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch(action.isLoading(true));
  dispatch(action.setLoginError(""));
  const firebase = getFirebase();
  firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then(res => {
      setupPresence(res.user.uid, firebase);

      dispatch(action.setLoginError(""));
      dispatch(action.isLoading(false));
      dispatch(action.setLoginSuccess(res));
    })
    .catch(error => {
      console.log("error", error.code);
      dispatch(action.isLoading(false));
      if (error.code == "auth/user-not-found") {
        dispatch(action.setLoginError("Email e senha incorretos"));
      } else if (error.code == "auth/invalid-email") {
        dispatch(action.setLoginError("Email inválido"));
      } else if (error.code == "auth/wrong-password") {
        dispatch(action.setLoginError("Senha inválida"));
      } else {
        dispatch(action.setLoginError("Ops! Não foi possível realizar login"));
      }
    });
}; */

/* export const setupPresence = (userId, firebase) => {
  const firestoreDb = firebase.firestore();
  const oldRealTimeDb = firebase.database();

  const usersRef = firestoreDb.collection("users"); // Get a reference to the Users collection;
  const onlineRef = oldRealTimeDb.ref(".info/connected"); // Get a reference to the list of connections

  onlineRef.on("value", snapshot => {
    oldRealTimeDb
      .ref(`/status/${userId}`)
      .onDisconnect() // Set up the disconnect hook
      .set("offline") // The value to be set for this key when the client disconnects
      .then(() => {
        // Set the Firestore User's online status to true
        usersRef.doc(userId).set(
          {
            is_online: true
          },
          { merge: true }
        );

        // Let's also create a key in our real-time database
        // The value is set to 'online'
        oldRealTimeDb.ref(`/status/${userId}`).set("online");
      });
  });
}; */

export const createAccount = payload => async dispatch => {
  dispatch(action.isLoading(true));
  dispatch(action.setCreateAccountError(""));
  try {
    const response = await fetch(`${baseUrl}/register`, {
      method: "post",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    localStorage.setItem(storageKey, JSON.stringify(result));
    socket.emit(EVENTS.HAS_ENTERED, { userId: result._id });
    dispatch(action.isLoading(false));
    dispatch(action.setCreateAccountError(""));
    dispatch(action.setCreateAccountSuccess(result));
    return result;
  } catch (error) {
    console.log(error);
    dispatch(action.isLoading(false));
    dispatch(
      action.setCreateAccountError("Não foi possível realizar esta ação.")
    );
  }
};

/* export const createAccount = (first_name, last_name, email, password, type) => (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(action.isLoading(true));
    dispatch(action.setCreateAccountError(""))
    const firebase = getFirebase()
    const firestore = getFirestore()
    firebase.auth().createUserWithEmailAndPassword(
            email,
            password
    ).then(res => {
    return firestore.collection('users').doc(res.user.uid).set({
            first_name:first_name,
            last_name:last_name,
            init_user_type: type,
            is_online: false, 
            is_professional: type == 'consultant' ? true : false,
            active:false,
            avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
            category: "categories/4YtVwSIb4Ut42vJrI9S2"

        })
    }).then(() => {
        dispatch(action.isLoading(false));
        dispatch(action.setCreateAccountError(""))
        dispatch(action.setCreateAccountSuccess())
    })
    .catch(error => {
        console.log('error', error.code)
        dispatch(action.isLoading(false));
        if(error.code == 'auth/email-already-in-use'){
            dispatch(action.setCreateAccountError('O endereço de e-mail já está sendo usado por outra conta.'))
        } else if(error.code == 'auth/invalid-email'){
            dispatch(action.setCreateAccountError('Email inválido.'))
        } else if(error.code == 'auth/wrong-password'){
            dispatch(action.setCreateAccountError('Senha inválido.'))
        } else {
            dispatch(action.setCreateAccountError('Ops! Não foi possível realizar login.'))
        }
    })
} */

const cleanUpdateMessage = dispatch => {
  dispatch(action.setUpdateLoading(false));
  setTimeout(() => {
    dispatch(action.cleanUpdateMsgs());
  }, 1000);
};

export const updateProfile = (id, token, changes) => async dispatch => {
  dispatch(action.setUpdateLoading(true));
  try {
    const response = await fetch(`${baseUrl}/users/${id}`, {
      method: "PATCH",
      body: JSON.stringify(changes),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    dispatch(
      action.setChangeUpdateSuccess("Perfil atualizado com sucesso.", changes)
    );
    setTimeout(() => dispatch(action.setChangeUpdateSuccess("", {})), 3000);
    dispatch(action.setUpdateLoading(false));
    localStorage.setItem(storageKey, JSON.stringify({ ...result, token }));
    return result;
  } catch (error) {
    console.log(error);
    dispatch(action.setUpdateError("Ocorreu um erro ao atualizar seu perfil."));
    setTimeout(() => dispatch(action.setUpdateError("")), 3000);
    dispatch(action.setUpdateLoading(false));
  }
};

export const updateCustomerId = (id, token, customerId) => async dispatch => {
  try {
    const response = await fetch(`${baseUrl}/users/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ customerId }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    dispatch(
      action.setChangeUpdateSuccess("Perfil atualizado com sucesso.", {
        customerId
      })
    );
    setTimeout(() => dispatch(action.setChangeUpdateSuccess("", {})), 3000);
    localStorage.setItem(storageKey, JSON.stringify({ ...result, token }));
    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

export const updateHasCard = (id, token) => async dispatch => {
  try {
    const response = await fetch(`${baseUrl}/users/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ hasCard: true }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    dispatch(
      action.setChangeUpdateSuccess("Perfil atualizado com sucesso.", {
        hasCard: true
      })
    );
    setTimeout(() => dispatch(action.setChangeUpdateSuccess("", {})), 3000);
    localStorage.setItem(storageKey, JSON.stringify({ ...result, token }));
    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const UpdatePersonalAccount = (uid, email, first_name, last_name) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firestore = getFirestore();
  const firebase = getFirebase();
  const user = firebase.auth().currentUser;
  dispatch(action.setUpdateLoading(true));
  if (user.email !== email) {
    //update email auth
    console.log(user);
    user
      .updateEmail(email)
      .then(() =>
        firestore
          .collection("users")
          .doc(uid)
          .update({
            email: email,
            first_name: first_name,
            last_name: last_name
          })
      )
      .then(res => {
        console.log("sucesso");
        dispatch(
          action.setChangeUpdateSuccess("Perfil atualizado com sucesso.")
        );
        cleanUpdateMessage(dispatch);
      })
      .catch(error => {
        console.log("error", error);
        if (error.code == "auth/requires-recent-login") {
          dispatch(
            action.setUpdateError(
              "Realize seu login novamente para poder atualizar seu e-mail."
            )
          );
          cleanUpdateMessage(dispatch);
        } else {
          dispatch(
            action.setUpdateError("Ocorreu um erro ao atualizar seu perfil.")
          );
          cleanUpdateMessage(dispatch);
        }
      });
    return;
  }

  //console.log('hasnt changed email');

  firestore
    .collection("users")
    .doc(uid)
    .update({ email: email, first_name: first_name, last_name: last_name })
    .then(function(res) {
      dispatch(action.setChangeUpdateSuccess("Perfil atualizado com sucesso."));
      cleanUpdateMessage(dispatch);
    })
    .catch(function(error) {
      console.log("error", error);
      dispatch(
        action.setUpdateError("Ocorreu um erro ao atualizar seu perfil.")
      );
      cleanUpdateMessage(dispatch);
      // dispatch(action.setChangeUpdateError())
    });
}; */
export const updateProfessionalAccount = async (id, token, changes) => {
  try {
    const response = await fetch(`${baseUrl}/professionals/${id}`, {
      method: "PATCH",
      body: JSON.stringify(changes),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      return { error: true };
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};
/* export const updateProfessionalAccount = (uid, payload) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch(action.setUpdateLoading(true));
  const firestore = getFirestore();
  const updateObject = {
    professional_description: payload.professional_description,
    category: payload.category,
    chat_price: payload.chat_price,
    video_price: payload.video_price,
    schedule: payload.schedule,
    holder_name: payload.holder_name,
    bank_account: payload.bank_account,
    bank_agency: payload.bank_agency,
    account_taxpayer: payload.account_taxpayer,
    completed: true,
    is_professional: true
  };
  if (payload.photo) {
    updateObject.avatar = payload.photo;
  }
  if (payload.id_document) updateObject.id_document = payload.id_document;
  if (payload.professional_document)
    updateObject.professional_document = payload.professional_document;
  firestore
    .collection("users")
    .doc(uid)
    .update({
      ...updateObject
    })
    .then(function(res) {
      console.log("sucesso");
      dispatch(action.setChangeUpdateSuccess("Perfil atualizado com sucesso."));
      setTimeout(() => {
        dispatch(action.cleanUpdateMsgs());
      }, 1000);
      dispatch(action.setUpdateLoading(false));
    })
    .catch(function(error) {
      console.log("error", error);
      dispatch(
        action.setUpdateError("Ocorreu um erro ao atualizar seu perfil.")
      );
      setTimeout(() => {
        dispatch(action.cleanUpdateMsgs());
      }, 1000);
      dispatch(action.setUpdateLoading(false));
      // dispatch(action.setChangeUpdateError())
    });
}; */

export const recoverPassword = email => async dispatch => {
  try {
    const response = await fetch(`${baseUrl}/reset-password/`, {
      method: "post",
      body: JSON.stringify({ email }),
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    //const result = await response.json();
    dispatch(action.setResetPasswordSuccess());
    //return result;
  } catch (error) {
    console.log(error);
    dispatch(action.setResetPasswordError());
  }
};

/* export const recoverPassword = email => (
  dispatch,
  getState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  return firebase
    .auth()
    .sendPasswordResetEmail(email)
    .then(res => {
      dispatch(action.setResetPasswordSuccess());
      console.log(res);
      return res;
    })
    .catch(err => {
      dispatch(action.setResetPasswordError());
      console.log(err);
    });
}; */

export const uploadImage = async (data, token) => {
  try {
    const formData = new FormData();

    formData.append("image", data);

    const response = await fetch(`${baseUrl}/uploadImage/`, {
      method: "post",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw { error: true };
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

export const uploadProfilePhoto = async (data, userId, token) => {
  try {
    const formData = new FormData();

    formData.append("id", userId);
    formData.append("profilePhoto", data);

    const response = await fetch(`${baseUrl}/updateProfilePhoto/`, {
      method: "post",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw { error: true };
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const sendImage = image => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  return new Promise((resolve, reject) => {
    const sessionId = new Date().getTime();
    const imageRef = firebase
      .storage()
      .ref("images")
      .child(`${sessionId}`);

    return imageRef
      .put(image, { contentType: image.mime })
      .then(() => {
        return imageRef.getDownloadURL();
      })
      .then(url => {
        return url;
        // return firestore.collection('users').doc(id).update({
        //     image: url ? url : '',
        // })
      })
      .then(res => {
        resolve(res);
        return res;
      })
      .catch(error => {
        reject(error);
      });
  });
}; */

export const changePassword = (old_password, newPassword) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch(action.isLoading(true));
  const firebase = getFirebase();
  var user = firebase.auth().currentUser;
  const credentials = firebase.auth.EmailAuthProvider.credential(
    user.email,
    old_password
  );
  // reauthenticateWithCredential
  user
    .reauthenticateAndRetrieveDataWithCredential(credentials)
    .then(function(res) {
      user
        .updatePassword(newPassword)
        .then(function() {
          dispatch(action.setChangePassSuccess("Senha alterada com sucesso."));
          dispatch(action.isLoading(false));
        })
        .catch(function() {
          dispatch(action.isLoading(false));
          dispatch(action.setChangePassError("Houve um erro ao mudar senha."));
        });
    })
    .catch(function(error) {
      dispatch(action.isLoading(false));
      if (error.code == "auth/wrong-password") {
        dispatch(action.setChangePassError("Senha atual incorreta."));
      } else {
        dispatch(action.setChangePassError("Houve um erro ao mudar senha."));
      }
    });
};
/* export const getUserInfo = uid => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firestore = getFirestore();
  firestore
    .doc("users/" + uid)
    .get()
    .then(res => {
      dispatch(action.getUserInfo(res.data()));
    });
}; */

/* export const getUserInfo = (id, token) => {
    
} */

export const signOut = userId => async dispatch => {
  //exclude from local storage
  localStorage.removeItem(storageKey);
  socket.off(`notification-${userId}`);
  socket.emit(EVENTS.HAS_LEFT, { userId });
  dispatch(action.setLogoutSuccess());
};

export const checkLogin = () => async dispatch => {
  const userInfo = localStorage.getItem(storageKey);
  if (userInfo) {
    const user = JSON.parse(userInfo);

    //check if token is valid

    const response = await fetch(`${baseUrl}/users/${user._id}`, {
      method: "get",
      headers: {
        Authorization: `Bearer ${user.token}`
      }
    });

    if (response.status === 401) {
      return;
    }

    if (!response.ok) {
      return;
    }

    const data = await response.json();

    subscribeToNotifications(data._id, dispatch);

    //set userInfo on user redux store
    dispatch(
      action.setLoginSuccess({
        ...data,
        token: user.token,
        professionalInfo: user.professionalInfo
      })
    );
    socket.emit(EVENTS.HAS_ENTERED, { userId: user._id });
  }
};

/* export const signOut = () => (dispatch, getState, { getFirebase }) => {
  const firebase = getFirebase();
  firebase
    .auth()
    .signOut()
    .then(() => {
      dispatch(action.setLogoutSuccess());
    })
    .catch(err => {
      console.log(err);
    });
}; */
